import { useQuery } from "@tanstack/react-query";

import { getExamQuestions } from "@/api/exams";
import type { QuizQuestion, QuizResult } from "@/types/common";

/** 특정 시험의 문항 목록 조회 (이미 답한 문항 정보 포함) */
export function useExamQuestionsQuery(examId: string | undefined) {
  return useQuery({
    queryKey: ["examQuestions", examId],
    queryFn: () => getExamQuestions(examId!),
    enabled: Boolean(examId),
    select: (examQuestions): { questions: QuizQuestion[]; answeredResults: QuizResult[] } => {
      const questions: QuizQuestion[] = [];
      const answeredResults: QuizResult[] = [];

      for (const eq of examQuestions) {
        const question: QuizQuestion = {
          id: eq.id,
          wordId: eq.word_id,
          word: eq.words?.word ?? "",
          meaning: eq.words?.meaning ?? "",
          options: [eq.option_1, eq.option_2, eq.option_3, eq.option_4],
          correctIndex: eq.correct_option - 1,
        };
        questions.push(question);

        if (eq.answered_at != null) {
          answeredResults.push({
            question,
            selectedOptionIndex: eq.selected_option != null ? eq.selected_option - 1 : null,
            isCorrect: eq.is_correct ?? false,
          });
        }
      }

      return { questions, answeredResults };
    },
  });
}
